import { useEffect, useState } from 'react';

// Module-level cache: the catalogue doesn't change within a session, and
// both the Display and Body font pickers need it — share one in-flight request,
// and let a failure clear it so the next mount retries instead of caching
// an error forever.
let cachedFontsPromise;

export function useGoogleFonts(fetchFonts) {
  const [fonts, setFonts] = useState([]);
  const [isLoading, setIsLoading] = useState(Boolean(fetchFonts));
  const [error, setError] = useState();

  useEffect(() => {
    let cancelled = false;
    if (!fetchFonts) {
      setIsLoading(false);
      return undefined;
    }

    if (!cachedFontsPromise) {
      cachedFontsPromise = fetchFonts().catch((err) => {
        cachedFontsPromise = undefined;
        throw err;
      });
    }

    setIsLoading(true);
    cachedFontsPromise
      .then((items) => {
        if (!cancelled) setFonts(items);
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [fetchFonts]);

  return { fonts, isLoading, error };
}
